import { call, put, all, spawn, takeEvery } from 'redux-saga/effects';
import { AUDIT_HEADER } from 'utils/constants';
import request from '../../utils/request';

import { showToast } from '../Toast/actions';
import { disableLoaderAction } from './actions';

import {
  ACTIVATE_INSTANT_REFUND_URL,
  GET_MERCHANT_PG_CONFIG_URL as MERCHANT_CONFIG_URL,
  UPDATE_MERCHANT_PG_CONFIG_URL,
} from '../../constants/url';

import {
  GET_PREFERENCES_DATA,
  SET_ORDER_EXPIRY_TIME,
  SET_TRANSACTION_COMPLETE_TIME,
  GET_ORDER_EXPIRY_TIME_URL,
  SET_ORDER_EXPIRY_TIME_URL,
  GET_TRANSACTION_COMPLETE_TIME_URL,
  SET_TRANSACTION_COMPLETE_TIME_URL,
  INSTANT_REFUND_STATUS,
  UPDATE_DEFAULT_REFUND_SPEED,
  UPDATE_NOTIFICATION_GROUP_URL,
  UPDATE_NOTIFICATION_GROUP,
} from './constants';

// Individual exports for testing

const SETTINGS_PREFERENCES_AUDIT = 'settings-preferences';

export function* getPreferencesData({ data }) {
  try {
    const { cb } = data;
    const promiseArr = [
      GET_ORDER_EXPIRY_TIME_URL,
      GET_TRANSACTION_COMPLETE_TIME_URL,
      // eslint-disable-next-line redux-saga/yield-effects
    ].map(obj => call(request, obj));
    const response = yield all(promiseArr);
    cb(response);
  } catch (err) {
    yield put(disableLoaderAction());
    yield put(showToast(err));
  }
}

export function* setOrderExpiryTime({ data }) {
  try {
    const { data: orderExpiry, cb } = data;
    const { url, method } = SET_ORDER_EXPIRY_TIME_URL;
    const options = {
      method,
      body: JSON.stringify(orderExpiry),
      headers: { [AUDIT_HEADER]: SETTINGS_PREFERENCES_AUDIT },
    };
    yield call(request, url, options);
    cb([
      {
        orderExpiry: orderExpiry.orderExpiry,
      },
      {
        transactionCompletionTimeMins: '',
      },
    ]);
    yield put(disableLoaderAction());
  } catch (err) {
    yield put(disableLoaderAction());
    yield put(showToast(err));
  }
}

export function* setTransactionCompleteTime({ data }) {
  try {
    const { data: transactionCompletionTimeMins, cb } = data;
    const { url, method } = SET_TRANSACTION_COMPLETE_TIME_URL;
    const options = {
      method,
      body: JSON.stringify(transactionCompletionTimeMins),
      headers: { [AUDIT_HEADER]: SETTINGS_PREFERENCES_AUDIT },
    };
    yield call(request, url, options);
    cb([
      {
        orderExpiry: '',
      },
      {
        transactionCompletionTimeMins:
          transactionCompletionTimeMins.transactionCompletionTimeMins,
      },
    ]);
    yield put(disableLoaderAction());
  } catch (err) {
    yield put(disableLoaderAction());
    yield put(showToast(err));
  }
}

export function* getMerchantIrConfig({ data: { configKey, cb } }) {
  try {
    const { url, method } = MERCHANT_CONFIG_URL;
    const options = {
      method,
      queryString: { configKey },
    };
    const response = yield call(request, url, options);
    cb(response);
  } catch (err) {
    yield put(disableLoaderAction());
    yield put(showToast(err));
  }
}

export function* updateDefautRefundSpeed({
  data: { configKey, configValue, isDefaultRefundSpeedPresent },
}) {
  try {
    let requestURL = '';
    let requestMethod = '';

    if (configValue === 'INSTANT') {
      requestURL = ACTIVATE_INSTANT_REFUND_URL.url;
      requestMethod = ACTIVATE_INSTANT_REFUND_URL.method;
    } else {
      requestURL = UPDATE_MERCHANT_PG_CONFIG_URL.url;
      requestMethod = isDefaultRefundSpeedPresent
        ? UPDATE_MERCHANT_PG_CONFIG_URL.method
        : 'POST';
    }

    const options = {
      method: requestMethod,
      body: JSON.stringify({ configKey, configValue }),
      headers: { [AUDIT_HEADER]: SETTINGS_PREFERENCES_AUDIT },
    };

    yield call(request, requestURL, options);
    yield put(disableLoaderAction());
  } catch (err) {
    yield put(disableLoaderAction);
    yield put(showToast(err));
  }
}

export function* updateNotificationGroup({ data: { method, body } }) {
  try {
    const { url } = UPDATE_NOTIFICATION_GROUP_URL;
    const options = {
      method,
      body: JSON.stringify(body),
    };
    yield call(request, url, options);
  } catch (err) {
    yield put(disableLoaderAction());
    yield put(showToast(err));
  }
}

export function* getPreferencesDataSaga() {
  yield takeEvery(GET_PREFERENCES_DATA, getPreferencesData);
}

export function* setOrderExpiryTimeSaga() {
  yield takeEvery(SET_ORDER_EXPIRY_TIME, setOrderExpiryTime);
}

export function* setTransactionCompleteTimeSaga() {
  yield takeEvery(SET_TRANSACTION_COMPLETE_TIME, setTransactionCompleteTime);
}

export function* getMerchantIrConfigSaga() {
  yield takeEvery(INSTANT_REFUND_STATUS, getMerchantIrConfig);
}

export function* updateDefaultRefundSpeedSaga() {
  yield takeEvery(UPDATE_DEFAULT_REFUND_SPEED, updateDefautRefundSpeed);
}

export function* updateNotificationGroupSaga() {
  yield takeEvery(UPDATE_NOTIFICATION_GROUP, updateNotificationGroup);
}

export default function* preferencesSaga() {
  // See example in containers/HomePage/saga.js
  const sagas = [
    getPreferencesDataSaga,
    setOrderExpiryTimeSaga,
    setTransactionCompleteTimeSaga,
    getMerchantIrConfigSaga,
    updateDefaultRefundSpeedSaga,
    updateNotificationGroupSaga,
  ];

  yield all(
    sagas.map(saga =>
      // eslint-disable-next-line func-names
      spawn(function*() {
        while (true) {
          try {
            yield call(saga);
            break;
          } catch (e) {
            // eslint-disable-next-line no-console
            console.log(e);
          }
        }
      }),
    ),
  );
}
